import TableSummaryExtend from './tableSummaryExtend'
import Auth from './auth'
import { App } from 'vue'
export default {
  install(app: App<Element>) {
    TableSummaryExtend.install(app)
    Auth.install(app)
  }
}
